import { useState } from 'react'

import Button from '@components/designSystem/Button'
import { useCurrentStoreId } from '@hooks/useCurrentStore.ts'
import { usePageHeader } from '@hooks/useHeader.ts'
import useTypedTranslation from '@hooks/useTypedTranslation.ts'
import StoreSelection from '@routes/StoreSelection/StoreSelection'
import { routesFactory } from '@utils/routes'

function ChangeStoreRoute() {
  const { t } = useTypedTranslation()
  usePageHeader({ title: t('account.store.title') })

  const currentStoreId = useCurrentStoreId()
  const [selectedStoreId, setSelectedStoreId] = useState(currentStoreId)

  return (
    <StoreSelection
      mode='radio'
      selectedStoreId={selectedStoreId}
      onStoreIdSelect={setSelectedStoreId}
      confirmBtn={
        <Button href={routesFactory.account(selectedStoreId)} size='xl' className='w-full'>
          {t('common.save')}
        </Button>
      }
    />
  )
}

export default ChangeStoreRoute